module.exports = __webpack_public_path__ + "img/inactive-2.2155aa8c.svg";